<p-toast />
<p-confirmDialog />
<div class="px-6 py-4">
  <div class="flex justify-content-between mb-4">
    <p class="text-xl font-semibold">{{ 'layout.configurations.country.title' | translate }}</p>
  <p-button *emPermission="Permission.CONFIG_BSA" class="p-button-success" icon="pi pi-plus" severity="success" (onClick)="onAdd()"
    
    ></p-button>
  </div>
  <p-table
    [value]="countries"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10,20, 50, 100]"
    paginatorPosition="bottom"
    paginatorAlignment="center" 
    styleClass="w-full p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        <th scope="col" pSortableColumn="name" class="bg-white">
          {{'layout.configurations.country.label.nameEn'| translate}} <p-sortIcon field="name" />
        </th>
        <th scope="col" pSortableColumn="nameEs" class="bg-white">
          {{'layout.configurations.country.label.nameEs'| translate}}<p-sortIcon field="nameEs" />
        </th>
        <th scope="col" pSortableColumn="nameAr" class="bg-white">
          {{'layout.configurations.country.label.nameAr'| translate}}<p-sortIcon field="nameAr" />
        </th>
        <th scope="col" pSortableColumn="code" class="bg-white">
          {{'layout.configurations.country.label.code'| translate}} <p-sortIcon field="code" />
        </th>
      <th *emPermission="Permission.CONFIG_BSA" scope="col" class="bg-white w-10rem pl-3">{{ 'layout.configurations.country.actions' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-country>
      <tr>
        <td>{{ country.name }}</td>
        <td>{{ country.nameEs }}</td>
        <td>{{ country.nameAr }}</td>
        <td>{{ country.code }}</td>
      <ng-container *emPermission="Permission.CONFIG_BSA">
        <td class="px-4 py-2 flex flex-row-reverse flex-wrap gap-2">
          <p-button icon="pi pi-pencil" 
          [outlined]="true" 
          class="mr-2" 
          (onClick)="onEdit(country)"
          >
        </p-button>
          <p-button
            icon="pi pi-trash"
            severity="danger"
            [outlined]="true"
            (onClick)="onDelete($event, country.id)"
          ></p-button>
        </td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</div>
